<template>
  <div class="min-h-screen bg-white flex items-center justify-center p-4">
    <!-- Desktop (Electron): the page has no nav bar, so add a top strip as the
         window drag handle (56px = the titleBarOverlay height). Web build never
         renders it. -->
    <div
      v-if="isDesktop"
      class="titlebar-drag fixed top-0 left-0 right-0 h-14"
    ></div>
    <div class="max-w-md w-full">
      <!-- Logo Section -->
      <div class="text-center mb-8">
        <img 
          :src="logo" 
          alt="Logo" 
          class="h-16 mx-auto mb-4"
        />
      </div>

      <!-- Forgot Password Component -->
      <div class="bg-white rounded-lg shadow-lg p-6">
        <ForgotPassword @back-to-login="goToLogin" />
      </div>

      <!-- Footer -->
      <div class="text-center mt-6">
        <p class="text-gray-600 text-sm">
          {{ $t("forgot_password.footer_text") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ForgotPassword from '@/components/ForgotPassword.vue';
import { isDesktop } from '@/services/tenant.js';

export default {
  name: 'ForgotPasswordPage',
  components: {
    ForgotPassword,
  },
  data() {
    return { isDesktop };
  },
  computed: {
    logo() {
      // You can replace this with your actual logo path
      return require('@/assets/go_ucaas_logo.png');
    },
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style scoped>
.bg-gradient-to-br {
  background: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.from-blue-50 {
  --tw-gradient-from: #eff6ff;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(239, 246, 255, 0));
}

.to-indigo-100 {
  --tw-gradient-to: #e0e7ff;
}
</style>
